import { cn } from "@gigpro/ui/tailwind/cn";
import React from "react";
import { Input, type InputProps } from "../Input";
import { Label } from "../Label";

interface TextfieldProps extends InputProps {
  optional?: boolean;
  label?: React.ReactNode;
  description?: React.ReactNode;
  error?: React.ReactNode;
  Tooltip?: React.ReactNode;
  placeholder?: string;
}

export function Textfield({
  className,
  optional,
  label,
  error,
  Tooltip,
  description,
  placeholder,
  value,
  onChange,
  ...props
}: Readonly<TextfieldProps>) {
  const id = React.useId();
  return (
    <div className={cn("flex flex-col gap-0.5", className)}>
      <Label
        className={cn("flex gap-1 text-normal font-semibold", error && "text-error")}
        htmlFor={id}
        optional={optional}
      >
        {label}
        {Tooltip}
      </Label>
      <Input
        id={id}
        className="w-full"
        placeholder={placeholder}
        invalid={!!error}
        value={value}
        onChange={onChange}
        {...props}
      />
      {!!description && <p className="text-small text-black">{description}</p>}
      {!!error && <p className="text-normal font-semibold text-error">{error}</p>}
    </div>
  );
}
